import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from '@pancakeswap/uikit'
import { FooterProps } from './types'
import { darkColors } from './colors'
import SocialLinks from './SocialLinks'

export const StyledFooter = styled(Flex)`
  background: ${darkColors.backgroundAlt};
`

export const StyledList = styled.ul`
  list-style: none;
  margin-bottom: 40px;
  ${({ theme }) => theme.mediaQueries.md} {
    margin-bottom: 0px;
  }
`

export const StyledListItem = styled.li`
  font-size: 16px;
  margin-bottom: 8px;
  text-transform: capitalize;
  &:first-child {
    color: ${darkColors.secondary};
    font-weight: 600;
    text-transform: uppercase;
  }
`

export const StyledIconMobileContainer = styled(Box)`
  margin-bottom: 24px;
`

export const StyledToolsContainer = styled(Flex)`
  border-color: ${darkColors.cardBorder};
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  padding: 24px 0;
  margin-bottom: 24px;
  ${({ theme }) => theme.mediaQueries.sm} {
    border-top-width: 0;
    border-bottom-width: 0;
    padding: 0 0;
    margin-bottom: 0;
  }
`

export const StyledSocialLinks = styled(SocialLinks)`
  border-bottom: 1px solid ${darkColors.cardBorder};
`

const MenuItem: React.FC<FooterProps> = ({ ...props }) => {
  return (
    <StyledFooter p={['20px 10px', null, '30px 40px 0px 40px']} {...props} justifyContent="center">
      <Flex flexDirection="column" width={['100%', null, '1200px;']}>
        <StyledSocialLinks justifyContent="center" pb={['20px', null, '20px']} mb={['0', null, '0']} />
      </Flex>
    </StyledFooter>
  )
}

export default MenuItem
